// src/context/alert/AlertProvider.js
import React, { useState, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { AlertContext } from './alertContext';

export const AlertProvider = ({ children }) => {
    const [alerts, setAlertsState] = useState([]);

    const removeAlert = useCallback((id) => {
        setAlertsState(prev => prev.filter(alert => alert.id !== id));
    }, []);

    const setAlert = useCallback((msg, type, timeout = 5000) => {
        const id = uuidv4();
        // Usamos um nome diferente (setAlertsState) para evitar conflito de nomes
        setAlertsState(prev => [...prev, { id, msg, type }]);

        if (timeout > 0) {
            setTimeout(() => removeAlert(id), timeout);
        }
    }, [removeAlert]);

    return (
        <AlertContext.Provider value={{ alerts, setAlert, removeAlert }}>
            {children}
        </AlertContext.Provider>
    );
};